import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularBuildingBank: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_building-bank"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="building-bank icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M13 6.25C13 6.80228 12.5523 7.25 12 7.25C11.4477 7.25 11 6.80228 11 6.25C11 5.69772 11.4477 5.25 12 5.25C12.5523 5.25 13 5.69772 13 6.25ZM13.0316 2.32431C12.417 1.87582 11.583 1.87582 10.9684 2.32431L3.54657 7.74026C2.56949 8.45327 3.07382 10 4.2834 10H4.5L4.5 15.7999C3.60958 16.255 3 17.1813 3 18.25V19.75C3 20.1642 3.33579 20.5 3.75 20.5H20.25C20.6642 20.5 21 20.1642 21 19.75V18.25C21 17.1813 20.3904 16.255 19.5 15.7999V10H19.7166C20.9262 10 21.4305 8.45327 20.4534 7.74026L13.0316 2.32431ZM11.8526 3.536C11.9404 3.47193 12.0596 3.47193 12.1474 3.536L18.9499 8.5H5.05011L11.8526 3.536ZM18 10V15.5H16V10H18ZM14.5 10V15.5H12.75V10H14.5ZM11.25 10V15.5H9.5L9.5 10H11.25ZM5.75 17H18.25C18.9404 17 19.5 17.5596 19.5 18.25V19H4.5V18.25C4.5 17.5596 5.05964 17 5.75 17ZM6 15.5L6 10H8L8 15.5H6Z" />
      </svg>
    </span>
  );
};

export { RegularBuildingBank };
